import styled from 'styled-components';
import GetLandShpaeImage from '../../../../func/components/GetLandShapeImage';
import { LandInfoProprs } from '../../data';
interface Props {
  landInfo: LandInfoProprs;
}

const LandImg = ({ landInfo }: Props) => {
  const shapeWithoutSuffix =
    landInfo && landInfo.shape
      ? landInfo.shape.slice(-1) === '형'
        ? landInfo.shape.slice(0, -1)
        : landInfo.shape
      : '';

  return (
    <LandImgContainer>
      {GetLandShpaeImage(shapeWithoutSuffix).text && (
        <>
          <img
            src={GetLandShpaeImage(shapeWithoutSuffix).img}
            alt=""
            style={{
              width: '94px',
              height: '52px',
              transform:
                shapeWithoutSuffix === '역삼각' ? 'rotate(180deg)' : '',
            }}
          />
          <InfoImgContentBox>
            <ShapeName>{shapeWithoutSuffix}형</ShapeName>
            <div>{GetLandShpaeImage(shapeWithoutSuffix).text}</div>
          </InfoImgContentBox>
        </>
      )}
    </LandImgContainer>
  );
};

export default LandImg;

const LandImgContainer = styled.div`
  width: 100%;
  height: 114px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-radius: 8px;
  padding: 24px;
  background-color: #eff2f5;
  align-items: center;
`;

const InfoImgContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: flex-start;
  align-items: flex-start;
  color: rgba(23, 30, 38, 0.56);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 17.4px;
  word-wrap: break-word;
`;

const ShapeName = styled.div`
  color: rgba(23, 30, 38, 0.78);
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
`;
